import React from 'react';

import { track } from '../../../lib/analytics';
import { Switch, Option } from './DeviceSwitcher.styles';

export type DeviceMode = 'mobile' | 'desktop';

export type DeviceSwitcherProps = {
  value: DeviceMode;
  onChange: (mode: DeviceMode) => void;
  /** Fully-rounded, fill-height variant for pairing beside the Live Preview pill (the
   *  tablet control bar) so both controls share a radius and height. Default look is the
   *  standalone Figma toggle. */
  pill?: boolean;
};

/** Mobile / Desktop pill toggle (Figma 1657-14835). */
export const DeviceSwitcher = ({ value, onChange, pill = false }: DeviceSwitcherProps): React.ReactElement => (
  <Switch $pill={pill}>
    {(['mobile', 'desktop'] as const).map((mode) => (
      <Option
        key={mode}
        text={mode === 'mobile' ? 'Mobile' : 'Desktop'}
        $active={value === mode}
        $pill={pill}
        onClick={() => {
          // Option renders via <Text> (no DOM data-* / auto-capture), so emit directly.
          track({ name: 'ui_click', gaId: `cfg-wizard-device-${mode}`, derived: false });
          onChange(mode);
        }}
      />
    ))}
  </Switch>
);

export default DeviceSwitcher;
